/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetCompanyResponse } from '../models/get-company-response';
import { CreateCompanyRequest } from '../models/create-company-request';
import { UpdateCompanyRequest } from '../models/update-company-request';
@Injectable({
  providedIn: 'root',
})
class CompanyService extends __BaseService {
  static readonly CompanyGetAllWithFilterPath = '/Company/GetAllWithFilter';
  static readonly CompanyGetAllPath = '/Company/GetAll';
  static readonly CompanyGetByIdPath = '/Company/GetById';
  static readonly CompanyCreatePath = '/Company/Create';
  static readonly CompanyCreateRangePath = '/Company/CreateRange';
  static readonly CompanyUpdatePath = '/Company/Update';
  static readonly CompanyDeletePath = '/Company/Delete';
  static readonly CompanyDeleteRangePath = '/Company/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param stageManagerId undefined
   */
  CompanyGetAllWithFilterResponse(stageManagerId?: null | string): __Observable<__StrictHttpResponse<Array<GetCompanyResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (stageManagerId != null) __params = __params.set('stageManagerId', stageManagerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Company/GetAllWithFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetCompanyResponse>>;
      })
    );
  }
  /**
   * @param stageManagerId undefined
   */
  CompanyGetAllWithFilter(stageManagerId?: null | string): __Observable<Array<GetCompanyResponse>> {
    return this.CompanyGetAllWithFilterResponse(stageManagerId).pipe(
      __map(_r => _r.body as Array<GetCompanyResponse>)
    );
  }
  CompanyGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetCompanyResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Company/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetCompanyResponse>>;
      })
    );
  }  CompanyGetAll(): __Observable<Array<GetCompanyResponse>> {
    return this.CompanyGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetCompanyResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  CompanyGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetCompanyResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/Company/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetCompanyResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  CompanyGetById(Id?: string): __Observable<GetCompanyResponse> {
    return this.CompanyGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetCompanyResponse)
    );
  }

  /**
   * @param request undefined
   */
  CompanyCreateResponse(request: CreateCompanyRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Company/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  CompanyCreate(request: CreateCompanyRequest): __Observable<Blob> {
    return this.CompanyCreateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  CompanyCreateRangeResponse(request: Array<CreateCompanyRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/Company/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  CompanyCreateRange(request: Array<CreateCompanyRequest>): __Observable<Blob> {
    return this.CompanyCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  CompanyUpdateResponse(request: UpdateCompanyRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/Company/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  CompanyUpdate(request: UpdateCompanyRequest): __Observable<Blob> {
    return this.CompanyUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  CompanyDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/Company/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  CompanyDelete(id?: string): __Observable<Blob> {
    return this.CompanyDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  CompanyDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/Company/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  CompanyDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.CompanyDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module CompanyService {
}

export { CompanyService }
